var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-phone-maintenance",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes slideUp{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:inherit}}@keyframes lightSpeedLeft{60%{transform:skewX(-10deg);opacity:1}80%{transform:skewX(2deg)}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}@keyframes wind{0%{transform:rotate(0deg)}25%{transform:rotate(1deg)}75%{transform:rotate(-1deg)}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}svg#freepik_stories-phone-maintenance:not(.animated) .animable{opacity:0}")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-77",
    style: {
      transformOrigin: "269.35px 247.735px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "154.375px 450.605px 0"
    },
    id: "ell571p20qbke",
    className: "animable",
    d: "M107.43 435.34v30.53h93.89v-30.53h-93.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "154.05px 431.075px 0"
    },
    id: "elirs6h4znw3",
    className: "animable",
    d: "M103.49 426.81v8.53h101.12v-8.53H103.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "178.345px 446.34px 0"
    },
    id: "elsso7eyr6g",
    className: "animable",
    d: "M154.05 465.87h47.27v-30.53h3.29v-8.53h-52.53v7.74l1.97 31.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "130.08px 442.56px 0"
    },
    id: "eluw684et1e",
    className: "animable",
    d: "M120.56 440.26h19.04v4.6h-19.04z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "130.335px 455.46px 0"
    },
    id: "ellhxyl68z69",
    className: "animable",
    d: "M118.11 450.61h24.45v9.7h-24.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "168.825px 411.585px 0"
    },
    id: "eluzh2fw3h7ba",
    className: "animable",
    d: "M121.88 396.32v30.53h93.89v-30.53h-93.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "168.495px 392.05px 0"
    },
    id: "ell7c7880zsea",
    className: "animable",
    d: "M117.94 387.78v8.54h101.11v-8.54H117.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "192.79px 407.315px 0"
    },
    id: "elc1oga35mcxr",
    className: "animable",
    d: "M168.5 426.85h47.27v-30.53h3.28v-8.54h-52.52v7.75l1.97 31.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "144.53px 403.54px 0"
    },
    id: "elybv3m6xr8c",
    className: "animable",
    d: "M135.01 401.24h19.04v4.6h-19.04z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "144.785px 416.43px 0"
    },
    id: "elphhjo6tlpu",
    className: "animable",
    d: "M132.56 411.58h24.45v9.7h-24.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.37 59.74a33.55 33.55 0 0 1 8.1-3.52l1.66-8 13.53-.22 2 7.94a33.32 33.32 0 0 1 8.21 3.23l6.84-4.48 9.74 9.4-4.24 7a33.16 33.16 0 0 1 3.52 8.1l8 1.66.23 13.54L172 96.3a33.32 33.32 0 0 1-3.23 8.21l4.48 6.84-9.4 9.74-7-4.24a33.16 33.16 0 0 1-8.1 3.52l-1.66 8-13.53.23-2-7.94a33.32 33.32 0 0 1-8.21-3.23l-6.84 4.48-9.74-9.4 4.24-7a33.1 33.1 0 0 1-3.52-8.09l-8-1.67-.23-13.53 7.94-1.95a33.32 33.32 0 0 1 3.23-8.21L106 65.24l9.4-9.74 7 4.24zm7.22 18a14.52 14.52 0 1 0 20.53-.36 14.52 14.52 0 0 0-20.53.39z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "139.61px 88.3px 0"
    },
    id: "ellugznox4vog",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.08 43.61a39.53 39.53 0 0 1 9.64-4.19l2-9.54 16.11-.28 2.32 9.46a39.5 39.5 0 0 1 9.78 3.85l8.15-5.34 11.6 11.2-5.05 8.33a39.36 39.36 0 0 1 4.19 9.64l9.54 2 .28 16.12-9.46 2.32a39.89 39.89 0 0 1-3.85 9.78l5.34 8.15-11.2 11.59-8.33-5.05a39 39 0 0 1-9.64 4.19l-2 9.54-16.12.29-2.32-9.47a39.12 39.12 0 0 1-9.78-3.85l-8.15 5.34-11.59-11.19 5.05-8.33a39.15 39.15 0 0 1-4.19-9.64l-9.54-2-.29-16.12 9.47-2.32a39.42 39.42 0 0 1 3.85-9.78l-5.34-8.14 11.19-11.6 8.33 5zm8.6 21.47a17.29 17.29 0 1 0 24.45-.43 17.3 17.3 0 0 0-24.45.43z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "360.605px 77.635px 0"
    },
    id: "el48cfay66v7z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.52 174.48a30.76 30.76 0 0 1 7.53-3.27l1.55-7.45 12.59-.23 1.81 7.4a31 31 0 0 1 7.64 3l6.37-4.17 9.05 8.75-3.94 6.5a30.76 30.76 0 0 1 3.27 7.53l7.45 1.55.23 12.59-7.4 1.82a31.12 31.12 0 0 1-3 7.64l4.17 6.36-8.75 9.06-6.5-3.95a31.17 31.17 0 0 1-7.53 3.28l-1.55 7.45-12.59.22-1.82-7.39a31 31 0 0 1-7.64-3l-6.36 4.17-9.1-8.76 3.95-6.5a31.17 31.17 0 0 1-3.28-7.53l-7.41-1.55-.26-12.59 7.39-1.81a31 31 0 0 1 3-7.64l-4.17-6.37 8.74-9.06 6.51 3.95zm6.71 16.77a13.51 13.51 0 1 0 19.1-.33 13.51 13.51 0 0 0-19.1.33z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "358.535px 201.045px 0"
    },
    id: "el9anhg0hagbs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.73 135.74a17.38 17.38 0 0 1 4.18-1.82l.86-4.14 7-.12 1 4.11a16.71 16.71 0 0 1 4.24 1.67l3.54-2.32 5 4.86-2.19 3.61a17.06 17.06 0 0 1 1.82 4.19l4.14.86.12 7-4.11 1a17.21 17.21 0 0 1-1.66 4.24l2.31 3.54-4.86 5-3.61-2.19a17.38 17.38 0 0 1-4.18 1.82l-.87 4.14-7 .12-1-4.11a17.24 17.24 0 0 1-4.24-1.67l-3.54 2.32-5-4.86 2.19-3.61a17.45 17.45 0 0 1-1.82-4.19l-4.14-.86-.12-7 4.11-1a17.24 17.24 0 0 1 1.67-4.24l-2.32-3.54 4.86-5 3.62 2.19zm3.72 9.32a7.5 7.5 0 1 0 10.62-.19 7.5 7.5 0 0 0-10.62.19z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "418.615px 150.485px 0"
    },
    id: "elkkjeuv4f7v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.89 43.63a17 17 0 0 1 4.18-1.82l.86-4.14 7-.12 1 4.1a17.49 17.49 0 0 1 4.24 1.67l3.54-2.32 5 4.86-2.19 3.61a17 17 0 0 1 1.82 4.18l4.14.86.12 7-4.11 1a17.21 17.21 0 0 1-1.66 4.24l2.31 3.54-4.86 5-3.61-2.19a17 17 0 0 1-4.15 1.9l-.87 4.14-7 .13-1-4.11a17.24 17.24 0 0 1-4.24-1.67l-3.54 2.32-5-4.86 2.13-3.66a17.38 17.38 0 0 1-1.82-4.18l-4.13-.86-.13-7 4.11-1a17.16 17.16 0 0 1 1.7-4.25l-2.32-3.53 4.86-5 3.62 2.19zm3.72 9.37a7.5 7.5 0 1 0 10.62-.19 7.51 7.51 0 0 0-10.62.19z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "218.76px 58.41px 0"
    },
    id: "elyoufe4j1pz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.9 156.58a17 17 0 0 1 4.18-1.82l.86-4.14 7-.12 1 4.11a16.78 16.78 0 0 1 4.25 1.67l3.53-2.32 5 4.86-2.2 3.61a16.9 16.9 0 0 1 1.82 4.19l4.14.86.12 7-4.1 1a17.24 17.24 0 0 1-1.67 4.24l2.31 3.54-4.85 5-3.62-2.19a17.38 17.38 0 0 1-4.18 1.82l-.86 4.14-7 .12-1-4.11a17.16 17.16 0 0 1-4.25-1.67l-3.53 2.32-5-4.86 2.2-3.61a17.06 17.06 0 0 1-1.82-4.19l-4.14-.86-.13-7 4.11-1a17.09 17.09 0 0 1 1.67-4.24l-2.32-3.54 4.86-5 3.62 2.19zm3.73 9.32a7.5 7.5 0 1 0 10.61-.19 7.5 7.5 0 0 0-10.61.19z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "155.78px 171.325px 0"
    },
    id: "elc4hyr0p6fc",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-77",
    style: {
      transformOrigin: "250px 466.85px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) lightSpeedLeft",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.67 466.85c0 .14-95.22.26-212.66.26s-212.68-.11-212.68-.26 95.2-.26 212.68-.26 212.66.12 212.66.26z",
    style: {
      fill: "#263238",
      transformOrigin: "250px 466.85px 0"
    },
    id: "elz5m2yyy3awn",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-77",
    style: {
      transformOrigin: "257.46px 266.1px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown,1.5s Infinite linear wind",
      animationDelay: "0s,1s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m322.25 466.66-129.68-.08c-15.6 0-28.24-13.3-28.23-29.69l.06-341.67c0-16.4 12.66-29.69 28.27-29.68l129.68.08c15.6 0 28.24 13.3 28.23 29.69L350.52 437c0 16.38-12.66 29.67-28.27 29.66z",
    style: {
      fill: "#263238",
      transformOrigin: "257.46px 266.1px 0"
    },
    id: "el62sgte7zenw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.21 77.7h-25.14c-3.37 0-6.11 3-6.11 6.7v4.79c0 3.71-2.73 6.71-6.1 6.71h-49c-3.38 0-6.11-3-6.11-6.71v-4.8c0-3.7-2.73-6.71-6.1-6.71H192.8c-10.93 0-19.8 9.3-19.8 20.79l-.06 333.5c0 11.48 8.85 20.79 19.77 20.79l129.43.08c10.93 0 19.79-9.3 19.79-20.79L342 98.5c0-11.5-8.86-20.79-19.79-20.8z",
    style: {
      fill: "#fff",
      transformOrigin: "257.47px 265.26px 0"
    },
    id: "el95n6d0nskm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.24 241.47a9 9 0 1 1-9-9 9 9 0 0 1 9 9z",
    style: {
      fill: "#cf0a10",
      transformOrigin: "272.24px 241.47px 0"
    },
    id: "el3wm90rvm6yn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.46,
    cy: 241.47,
    rx: 9.6,
    ry: 9.62,
    style: {
      fill: "#cf0a10",
      transformOrigin: "245.46px 241.47px 0"
    },
    id: "eleicfj612t6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.89,
    cy: 224.45,
    rx: 10.19,
    ry: 10.21,
    style: {
      fill: "#cf0a10",
      transformOrigin: "224.89px 224.45px 0"
    },
    id: "elnnjfqwz6n3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.72,
    cy: 198.27,
    rx: 10.64,
    ry: 10.67,
    style: {
      fill: "#cf0a10",
      transformOrigin: "220.72px 198.27px 0"
    },
    id: "el5ssy78njha8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.75,
    cy: 175.36,
    rx: 11,
    ry: 11.03,
    style: {
      fill: "#cf0a10",
      transformOrigin: "233.75px 175.36px 0"
    },
    id: "elwofwx1h6y3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 258.8,
    cy: 166.3,
    rx: 11.99,
    ry: 12.02,
    style: {
      fill: "#cf0a10",
      transformOrigin: "258.8px 166.3px 0"
    },
    id: "elon6muon1jv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.82 224.24a8.71 8.71 0 1 1-8.71-8.73 8.72 8.72 0 0 1 8.71 8.73z",
    style: {
      fill: "#cf0a10",
      transformOrigin: "292.11px 224.22px 0"
    },
    id: "el6cfhf3pg4fa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.77,
    cy: 197.98,
    rx: 8.08,
    ry: 8.1,
    style: {
      fill: "#cf0a10",
      transformOrigin: "296.77px 197.98px 0"
    },
    id: "elnirvytfx5qc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.33,
    cy: 175.05,
    rx: 7.38,
    ry: 7.4,
    style: {
      fill: "#cf0a10",
      transformOrigin: "283.33px 175.05px 0"
    },
    id: "eltk99rws1oom",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3jfqvn47qvm"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "272.24px 241.47px 0"
    },
    className: "animable",
    id: "elm08l5hluwhl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.24 241.47a9 9 0 1 1-9-9 9 9 0 0 1 9 9z",
    style: {
      fill: "#fff",
      transformOrigin: "272.24px 241.47px 0"
    },
    id: "elole74n91ab",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elksjm4mzznqq"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "245.46px 241.47px 0"
    },
    className: "animable",
    id: "elxxx1q8fjirn"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.46,
    cy: 241.47,
    rx: 9.6,
    ry: 9.62,
    style: {
      fill: "#fff",
      transformOrigin: "245.46px 241.47px 0"
    },
    id: "elzyry037faao",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elma71zs5ztnd"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "224.89px 224.45px 0"
    },
    className: "animable",
    id: "elw7uwihl252"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.89,
    cy: 224.45,
    rx: 10.19,
    ry: 10.21,
    style: {
      fill: "#fff",
      transformOrigin: "224.89px 224.45px 0"
    },
    id: "elnyljly5fg7",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el1vxrjsla6fm"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "220.72px 198.27px 0"
    },
    className: "animable",
    id: "el3z96yp3pr1c"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.72,
    cy: 198.27,
    rx: 10.64,
    ry: 10.67,
    style: {
      fill: "#fff",
      transformOrigin: "220.72px 198.27px 0"
    },
    id: "elr9aqwu8g29",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elzfnh6dnfxlq"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "233.75px 175.36px 0"
    },
    className: "animable",
    id: "elvwinbasz6ec"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.75,
    cy: 175.36,
    rx: 11,
    ry: 11.03,
    style: {
      fill: "#fff",
      transformOrigin: "233.75px 175.36px 0"
    },
    id: "elnhgy78ercmp",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elr1ffn6jbfwp"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "258.8px 166.3px 0"
    },
    className: "animable",
    id: "ellogs1p5ai2m"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 258.8,
    cy: 166.3,
    rx: 11.99,
    ry: 12.02,
    style: {
      fill: "#fff",
      transformOrigin: "258.8px 166.3px 0"
    },
    id: "eltt5qqyr8e4",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elcyztrqh86bf"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "292.11px 224.22px 0"
    },
    className: "animable",
    id: "el67w0iwu4max"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.82 224.24a8.71 8.71 0 1 1-8.71-8.73 8.72 8.72 0 0 1 8.71 8.73z",
    style: {
      fill: "#fff",
      transformOrigin: "292.11px 224.22px 0"
    },
    id: "elvfz7f9x088",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elrjwoawc0pc"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      transformOrigin: "296.77px 197.98px 0"
    },
    className: "animable",
    id: "elwuyq1wtmyu7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.77,
    cy: 197.98,
    rx: 8.08,
    ry: 8.1,
    style: {
      fill: "#fff",
      transformOrigin: "296.77px 197.98px 0"
    },
    id: "elhe1t4b5jf1",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elqdstmzkd6op"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      transformOrigin: "283.33px 175.05px 0"
    },
    className: "animable",
    id: "elalks3a2xh75"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.33,
    cy: 175.05,
    rx: 7.38,
    ry: 7.4,
    style: {
      fill: "#fff",
      transformOrigin: "283.33px 175.05px 0"
    },
    id: "el9x93mlvufe",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M230.06 328a3.18 3.18 0 0 1 3.32-3.23 3.08 3.08 0 0 1 2.32.93l-.43.42a2.53 2.53 0 0 0-1.87-.75 2.63 2.63 0 1 0 0 5.26 2.5 2.5 0 0 0 1.87-.76l.43.42a3.1 3.1 0 0 1-2.33.94 3.18 3.18 0 0 1-3.31-3.23z",
    style: {
      fill: "#263238",
      transformOrigin: "232.88px 328px 0"
    },
    id: "ella4ijtp0q8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.42 324.77v6.35h-.66v-2.93h-4v2.93h-.67v-6.35h.67v2.84h4v-2.84z",
    style: {
      fill: "#263238",
      transformOrigin: "239.755px 327.945px 0"
    },
    id: "elgv6npmw3gwc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 330.54v.58h-4.48v-6.35h4.34v.58h-3.67v2.26h3.28v.58h-3.28v2.35z",
    style: {
      fill: "#263238",
      transformOrigin: "246.76px 327.945px 0"
    },
    id: "elgqenfptarpu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.94 328a3.18 3.18 0 0 1 3.32-3.23 3.08 3.08 0 0 1 2.32.93l-.43.42a2.53 2.53 0 0 0-1.87-.75 2.63 2.63 0 1 0 0 5.26 2.5 2.5 0 0 0 1.87-.76l.43.42a3.1 3.1 0 0 1-2.33.94 3.18 3.18 0 0 1-3.31-3.23z",
    style: {
      fill: "#263238",
      transformOrigin: "252.76px 328px 0"
    },
    id: "eluppl44ixzk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259 328.14-1.3 1.32v1.66h-.7v-6.35h.67v3.84l3.72-3.84h.77l-2.74 2.88 2.93 3.47h-.79z",
    style: {
      fill: "#263238",
      transformOrigin: "259.675px 327.945px 0"
    },
    id: "el1sc7naaeh3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.44 324.77h.67v6.35h-.67z",
    style: {
      fill: "#263238",
      transformOrigin: "263.775px 327.945px 0"
    },
    id: "el13wvt98bqgja",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.46 324.77v6.35h-.55l-4.07-5.12v5.15h-.67v-6.35h.55l4.08 5.16v-5.16z",
    style: {
      fill: "#263238",
      transformOrigin: "268.815px 327.96px 0"
    },
    id: "elzad0l4tiftn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278 328h.64v2.42a3.47 3.47 0 0 1-2.32.81 3.23 3.23 0 1 1 0-6.46 3.13 3.13 0 0 1 2.36.92l-.42.42a2.68 2.68 0 1 0-1.92 4.52 2.77 2.77 0 0 0 1.66-.49z",
    style: {
      fill: "#263238",
      transformOrigin: "275.882px 327.999px 0"
    },
    id: "eljy77bz90st",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.06 330.67a.48.48 0 0 1 .48-.49.49.49 0 0 1 .49.49.5.5 0 0 1-.49.5.49.49 0 0 1-.48-.5z",
    style: {
      fill: "#263238",
      transformOrigin: "280.545px 330.675px 0"
    },
    id: "eldjljx57km2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 330.67a.48.48 0 0 1 .48-.49.49.49 0 0 1 .49.49.5.5 0 0 1-.49.5.48.48 0 0 1-.48-.5z",
    style: {
      fill: "#263238",
      transformOrigin: "282.485px 330.675px 0"
    },
    id: "el83dw0unh6vr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.9 330.67a.48.48 0 0 1 .48-.49.48.48 0 0 1 .48.49.49.49 0 0 1-.48.5.48.48 0 0 1-.48-.5z",
    style: {
      fill: "#263238",
      transformOrigin: "284.38px 330.675px 0"
    },
    id: "elzubg4mfni8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.48,
    y: 288.03,
    width: 122.07,
    height: 24.3,
    rx: 11.22,
    style: {
      fill: "#f5f5f5",
      transformOrigin: "257.515px 300.18px 0"
    },
    id: "ela9k7j8itol5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.48,
    y: 288.03,
    width: 67.86,
    height: 24.3,
    rx: 11.22,
    style: {
      fill: "#cf0a10",
      transformOrigin: "230.41px 300.18px 0"
    },
    id: "el2z2vu4nraj9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.52 302c0 1.26-.87 2.22-2.63 2.22a3.58 3.58 0 0 1-2.64-1l.28-.42a3.15 3.15 0 0 0 2.35.93c1.39 0 2.1-.7 2.1-1.7s-.66-1.73-2.7-1.73h-1.52l.4-3.65h4v.5h-3.52l-.29 2.65h1.07c2.27-.05 3.1.82 3.1 2.2z",
    style: {
      fill: "#cf0a10",
      transformOrigin: "290.885px 300.437px 0"
    },
    id: "elhmvfenwee7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.46 302c0 1.26-.87 2.22-2.63 2.22a3.58 3.58 0 0 1-2.64-1l.28-.42a3.15 3.15 0 0 0 2.35.93c1.39 0 2.09-.7 2.09-1.7s-.65-1.73-2.69-1.73h-1.52l.39-3.65h4v.5h-3.53l-.28 2.65h1.07c2.27-.05 3.11.82 3.11 2.2z",
    style: {
      fill: "#cf0a10",
      transformOrigin: "296.825px 300.437px 0"
    },
    id: "eltemnn6b12kb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.28 298.59c0-1.22.68-2 1.65-2s1.67.81 1.67 2-.69 2-1.67 2-1.65-.77-1.65-2zm2.91 0c0-1-.51-1.66-1.26-1.66s-1.24.63-1.24 1.66.5 1.67 1.24 1.67 1.26-.63 1.26-1.67zm3.32-2h.49l-5.13 7.53h-.46zm-1.74 5.54c0-1.23.68-2 1.66-2s1.65.8 1.65 2-.67 2-1.65 2-1.66-.76-1.66-1.99zm2.9 0c0-1-.5-1.67-1.24-1.67s-1.26.63-1.26 1.67.51 1.67 1.26 1.67 1.24-.63 1.24-1.66z",
    style: {
      fill: "#cf0a10",
      transformOrigin: "304.18px 300.36px 0"
    },
    id: "elawwqw8eqgbe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eliyq2jerejso"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "224.475px 300.035px 0"
    },
    className: "animable",
    id: "elrfxr9dgik9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "224.475px 300.035px 0"
    },
    id: "elk2oqr4n1f4",
    className: "animable",
    d: "m225.99 288.03-9.12 24.01h6.7l8.51-24.01h-6.09z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el4amlnzvm483"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "240.925px 300.035px 0"
    },
    className: "animable",
    id: "elctu6rdfr6af"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "240.925px 300.035px 0"
    },
    id: "ele9bucub4ko",
    className: "animable",
    d: "m242.45 288.03-9.13 24.01h6.71l8.5-24.01h-6.08z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el8y0whzo1rb4"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "256.535px 301.015px 0"
    },
    className: "animable",
    id: "elnrrr3005stb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m258.57 289.84-8.5 22.35h4a15.72 15.72 0 0 0 3.08-1l5.85-16.56a13 13 0 0 0-4.43-4.79z",
    style: {
      fill: "#fff",
      transformOrigin: "256.535px 301.015px 0"
    },
    id: "elt1w0tqko1nq",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el49v9bea8lis"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "208.865px 300.005px 0"
    },
    className: "animable",
    id: "elq7le9dcibzq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m210 288-8.39 22.08a12 12 0 0 0 6 1.93l8.51-24z",
    style: {
      fill: "#fff",
      transformOrigin: "208.865px 300.005px 0"
    },
    id: "elf7321pwc1qj",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M307.11 312.33a16.17 16.17 0 0 0 2.73-.4 11.38 11.38 0 0 0 6.4-4.35 11.13 11.13 0 0 0 2.07-5.24 20.68 20.68 0 0 0 .08-3.27 11.06 11.06 0 0 0-.68-3.43 11.26 11.26 0 0 0-8.8-7.27 31.43 31.43 0 0 0-4.49-.15l-96.5.08a12.55 12.55 0 0 0-3.39.52 12 12 0 0 0-3.05 1.53 11.18 11.18 0 0 0-4 5.3c-1.35 4.21-.91 9.29 2 12.55a11.2 11.2 0 0 0 5.36 3.44c2 .62 4.23.39 6.37.44h12.54l43.38.05 29.25.09h10.77-2.77l-8 .05-29.25.08-43.38.06H208a12.66 12.66 0 0 1-3.28-.46 11.7 11.7 0 0 1-8.38-9.78 22.09 22.09 0 0 1-.08-3.45 11.19 11.19 0 0 1 .69-3.43 11.73 11.73 0 0 1 4.25-5.56 12.52 12.52 0 0 1 3.19-1.59 13 13 0 0 1 3.55-.55l96.5.07a31 31 0 0 1 4.56.34 11.53 11.53 0 0 1 9 7.52c1.46 4.76.6 9.41-1.58 12.16a11.39 11.39 0 0 1-6.54 4.34 7.9 7.9 0 0 1-1.19.21 4.87 4.87 0 0 1-.87.07c-.47.04-.71.03-.71.03z",
    style: {
      fill: "#263238",
      transformOrigin: "257.475px 300px 0"
    },
    id: "elbi0bdcnvpbc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.29 421.31v8.16a.9.9 0 0 1-1.38.76l-6.42-4.08a.91.91 0 0 1 0-1.52l6.42-4.08a.9.9 0 0 1 1.38.76z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "204.185px 425.39px 0"
    },
    id: "elho2r9mooeeg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261 425.31a5.63 5.63 0 1 1-5.63-5.64 5.63 5.63 0 0 1 5.63 5.64z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "255.37px 425.3px 0"
    },
    id: "el5pelv1e0usl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.44,
    y: 420.41,
    width: 10.38,
    height: 10.41,
    rx: 1.87,
    style: {
      fill: "#e0e0e0",
      transformOrigin: "306.63px 425.615px 0"
    },
    id: "el6jg0ncmdgok",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-77",
    style: {
      transformOrigin: "416.488px 362.403px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown,1.5s Infinite linear wind",
      animationDelay: "0s,1s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.55 286.89a72.24 72.24 0 0 0 .68-12.37 25.06 25.06 0 0 0-3.39-11.8c-.33-.53-2.94-4-3.54-3.84-.43.13 1.43 3.5 1.28 3.93a21.34 21.34 0 0 0 .12 12.63 55.69 55.69 0 0 0 4.85 11.45",
    style: {
      fill: "#263238",
      transformOrigin: "426.75px 272.882px 0"
    },
    id: "elyai0hgqkzoh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.37 314c-.61-2.86-1.1-5.11-1.12-5.1s-10 1-12.64-8.61c-1.26-4.64-3.08-14.4-4.63-23.25a18.54 18.54 0 0 1 13.62-21.14l.93-.24c10.17-2 17.56 5.51 19.29 15.73l7.18 35.53-15.79 16.75z",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "413.35px 289.503px 0"
    },
    id: "elhlmdm3cvd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.25 308.85a24.07 24.07 0 0 0 11.58-7s-1.16 7.93-11 9.55z",
    style: {
      fill: "#eb996e",
      transformOrigin: "416.04px 306.625px 0"
    },
    id: "elp6fqmaetsw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398 284.61a1.42 1.42 0 0 0 1.69 1 1.35 1.35 0 0 0 1.09-1.61 1.41 1.41 0 0 0-1.68-1 1.36 1.36 0 0 0-1.1 1.61z",
    style: {
      fill: "#263238",
      transformOrigin: "399.391px 284.305px 0"
    },
    id: "elauo9q2hd7o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.07 280.45c.22.14 1.06-.9 2.54-1.28s2.76.08 2.88-.15-.2-.38-.77-.6a3.91 3.91 0 0 0-2.35-.11 3.84 3.84 0 0 0-2 1.25c-.37.44-.37.83-.3.89z",
    style: {
      fill: "#263238",
      transformOrigin: "398.775px 279.321px 0"
    },
    id: "elvksi94ogir9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.39 281.93a1.42 1.42 0 0 0 1.69 1 1.35 1.35 0 0 0 1.1-1.6 1.43 1.43 0 0 0-1.69-1.05 1.37 1.37 0 0 0-1.1 1.65z",
    style: {
      fill: "#263238",
      transformOrigin: "412.782px 281.607px 0"
    },
    id: "el0ep8oaiq26bm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.73 277.29c.22.14 1.06-.9 2.54-1.28s2.76.08 2.87-.14-.2-.38-.76-.6a3.8 3.8 0 0 0-2.36-.11 3.74 3.74 0 0 0-2 1.24c-.32.47-.4.84-.29.89z",
    style: {
      fill: "#263238",
      transformOrigin: "413.423px 276.163px 0"
    },
    id: "el8xut16sdzh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.37 290a10.93 10.93 0 0 0-2.52.19c-.39.06-.77.08-.9-.16a2.07 2.07 0 0 1 0-1.19c.12-1 .25-2.06.38-3.17.49-4.5.74-8.16.56-8.17s-.73 3.61-1.22 8.11c-.11 1.11-.22 2.16-.32 3.17a2.29 2.29 0 0 0 .19 1.54 1 1 0 0 0 .76.39 2.62 2.62 0 0 0 .67-.08 9.93 9.93 0 0 0 2.4-.63z",
    style: {
      fill: "#263238",
      transformOrigin: "406.332px 284.105px 0"
    },
    id: "elayjxw1jvtfj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413 289.94c-.25.05.17 1.66-.91 3.15s-2.84 1.77-2.79 2 .46.22 1.19.05a4.17 4.17 0 0 0 2.35-1.57 3.58 3.58 0 0 0 .66-2.62c-.12-.7-.41-1.05-.5-1.01z",
    style: {
      fill: "#263238",
      transformOrigin: "411.417px 292.601px 0"
    },
    id: "elu5g2itijmjm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.25 271.27c.25.36 1.68-.21 3.47-.45s3.32-.13 3.46-.55c.06-.2-.29-.52-.95-.76a5.8 5.8 0 0 0-2.73-.23 5.91 5.91 0 0 0-2.55 1c-.57.41-.81.81-.7.99z",
    style: {
      fill: "#263238",
      transformOrigin: "412.705px 270.299px 0"
    },
    id: "el7n4lric485a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.41 275.37c.35.27 1.28-.34 2.5-.68s2.32-.36 2.47-.77c.06-.2-.19-.49-.73-.69a3.71 3.71 0 0 0-4 1.17c-.34.46-.4.84-.24.97z",
    style: {
      fill: "#263238",
      transformOrigin: "397.857px 274.244px 0"
    },
    id: "eluga83rn11ji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.88 278.68c.15-.11 6.11-3.67 7.61 3s-5.48 6.77-5.54 6.58-2.07-9.58-2.07-9.58z",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "431.791px 282.969px 0"
    },
    id: "elna4wqkyejap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.41 285.26s.14.05.35.1a1.2 1.2 0 0 0 .87-.18 2.9 2.9 0 0 0 .75-2.86 4 4 0 0 0-.7-1.59 1.35 1.35 0 0 0-1.07-.69.61.61 0 0 0-.61.47c-.05.21 0 .33 0 .35s-.17-.08-.17-.37a.74.74 0 0 1 .17-.49.88.88 0 0 1 .61-.31 1.67 1.67 0 0 1 1.44.75 4 4 0 0 1 .81 1.76c.26 1.35-.14 2.76-1 3.25a1.23 1.23 0 0 1-1.1.06c-.3-.09-.37-.23-.35-.25z",
    style: {
      fill: "#eb996e",
      transformOrigin: "432.384px 282.651px 0"
    },
    id: "eluhj7e1ke0es",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.9 265c-1.2-.36 1.28-4.55 3.66-6.32 3.61-2.68 9.48-5.12 13.39-4.87 4.71.3 8.87 1.72 12 5.27a26.83 26.83 0 0 1 5.82 12.73 8.24 8.24 0 0 1-.06 4.27c-.61 1.67-2.2 3-1.68 5a2.85 2.85 0 0 1-.25 2.18c-.94 1.56-2.69.67-3.64-.41-2-2.29-2.86-5.36-3.63-8.32a19.84 19.84 0 0 1-.95-6.42c.09-1.18.38-2.34.41-3.52a4.1 4.1 0 0 0-1.19-3.22 5.44 5.44 0 0 0-.66-.43 7.1 7.1 0 0 0-7.17.18c-3.46 2.13-9.43 5.49-11.37 4.58a10.44 10.44 0 0 1-3.63-2.38z",
    style: {
      fill: "#263238",
      transformOrigin: "412.305px 268.947px 0"
    },
    id: "ela5fn7zp7lg6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.51 250.15c.46-.05 11.72-.34 16.39 6.92s4.5 9.89 4.5 9.89a5.44 5.44 0 0 1 1.36.67c.57.41.56 3.08-.9 3.15-11.57-2-24 .68-37.61 4.57l-10.54 2.53c-2.85 1.09-4.08.57-3-.49.81-.8 8.31-6.26 8.31-6.26l1.33-1.62 2.82-7.11s-.75-.7.14-1.66 8.21-9.6 17.2-10.59z",
    style: {
      fill: "#cf0a10",
      transformOrigin: "406.716px 264.31px 0"
    },
    id: "eljchb09og5cs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.32 269.51a2.83 2.83 0 0 0 .41-.1l1.17-.32c1-.3 2.48-.66 4.31-1.08a84.26 84.26 0 0 1 14.53-1.83 130.67 130.67 0 0 1 14.66.32c1.88.13 3.39.27 4.44.36l1.2.1h.42l-.41-.06-1.21-.13c-1-.11-2.55-.27-4.43-.41a118.27 118.27 0 0 0-14.67-.38 81 81 0 0 0-14.56 1.88c-3.66.88-5.86 1.65-5.86 1.65z",
    style: {
      fill: "#263238",
      transformOrigin: "410.89px 267.706px 0"
    },
    id: "el1a78gt6aj7z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elva1fucq9wrr"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "410.045px 256.177px 0"
    },
    className: "animable",
    id: "el8aqa5se797w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.42 252.36s-11.95 1-16.46 4.82l.52-.45-4.32 3.37a3.11 3.11 0 0 1-2.49.95 23.31 23.31 0 0 1 6.39-5.82c4.39-2.84 11.84-5.47 16.36-2.87z",
    id: "eliameycdeeui",
    style: {
      transformOrigin: "410.045px 256.177px 0"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M421.6 252.38a8.7 8.7 0 0 0-1.2-.41 14.78 14.78 0 0 0-3.41-.54 17.8 17.8 0 0 0-5.1.54 14.85 14.85 0 0 0-5.66 2.67 25.55 25.55 0 0 0-2.4 2.21c-.73.75-1.47 1.44-2.11 2.17a14.87 14.87 0 0 1-1.87 2 5.23 5.23 0 0 1-2.1 1c-2.81.75-4.69.6-4.61.39a.4.4 0 0 0 .28.17 3.43 3.43 0 0 0 .94.07 15.82 15.82 0 0 0 3.42-.51 5.17 5.17 0 0 0 2.17-1 15.66 15.66 0 0 0 1.9-2c.63-.71 1.38-1.41 2.11-2.16a26.32 26.32 0 0 1 2.38-2.18 14.85 14.85 0 0 1 5.59-2.66 17.92 17.92 0 0 1 5.05-.57 15.44 15.44 0 0 1 3.41.48l.9.25a2.3 2.3 0 0 0 .31.08z",
    style: {
      fill: "#263238",
      transformOrigin: "407.369px 257.037px 0"
    },
    id: "el8bsgg4f464r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmk58w2w9qad"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "420.25px 261.312px 0"
    },
    className: "animable",
    id: "elnvfgzpdq2x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.73 260.13a27.54 27.54 0 0 1-5.91.44c-2.3.07-4.55.24-6.85.21-1.74 0-3.77.07-5.13-.84a2.45 2.45 0 0 0 1.29 2 11.93 11.93 0 0 0 3.88.66 62.39 62.39 0 0 0 13.65-.79 13.88 13.88 0 0 0-.93-1.72",
    id: "elgx8xqhzv1ew",
    style: {
      transformOrigin: "420.25px 261.312px 0"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M426.35 256.28c1.44.24 2.34.42 2.66 1.52.26.91.36 2.09-.51 2.48a2.21 2.21 0 0 1-.85.15l-14.93.74a2.15 2.15 0 0 1-1.46-.27 1.49 1.49 0 0 1 0-2.08 4 4 0 0 1 2.05-1 48.87 48.87 0 0 1 13-1.51",
    style: {
      fill: "#cf0a10",
      transformOrigin: "420.015px 258.74px 0"
    },
    id: "el2lax8ptkjhn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.53 261.05a1.45 1.45 0 0 1-.54-.52 1.86 1.86 0 0 1 .13-1.94 4.57 4.57 0 0 1 2.7-1.36c1.15-.23 2.43-.47 3.77-.67a38.61 38.61 0 0 1 6.93-.5c.89 0 1.6.08 2.1.12l.57.06h.2l-.19-.05-.57-.09c-.5-.06-1.22-.15-2.11-.18a35.78 35.78 0 0 0-7 .45c-1.34.2-2.62.45-3.77.69a4.62 4.62 0 0 0-2.77 1.44 1.92 1.92 0 0 0-.09 2.06 1.17 1.17 0 0 0 .42.4z",
    style: {
      fill: "#263238",
      transformOrigin: "419.012px 258.475px 0"
    },
    id: "eldwk8nxqozvd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "396.2px 264.665px 0"
    },
    id: "el40jrp2l1sd8",
    className: "animable",
    d: "m392.26 264.63 8.88-2.45-.11 2.71-9.77 2.26 1-2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.78 269.14c0-.05-4.13.39-9.22 1s-9.2 1.12-9.2 1.17 4.14-.39 9.22-1 9.21-1.12 9.2-1.17z",
    style: {
      fill: "#263238",
      transformOrigin: "398.57px 270.225px 0"
    },
    id: "elkovvg8w2d6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382.12 323.67 9 21.84 4-16.79a19.92 19.92 0 0 1 4.71-8.66 21.23 21.23 0 0 1 2.6-2.32l7.07 32.38s-6 18.44-20.25 18.87c-4.14.12-10.45-2.51-12.42-7.12-1-2.28-13.67-32.36-13.67-32.36z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "386.33px 343.367px 0"
    },
    id: "elflqf4v1glsg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "382.125px 342.69px 0"
    },
    id: "el0ool3ce2bvu",
    className: "animable",
    d: "m385.97 341.13.51-3.23-10.61-9-1.88 2.11-6.05 6.93 22.86 18.54 5.51-6.62-10.34-8.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.69 381.59c.3-4.5-5.16-56-5.16-56l-11.71-17.3-22.33-3.93c-.34 2.72-2.09 9.82-11.3 12.44-4.74 1.35-9.89-3.38-9.89-3.38l-8.87 4.31 3.37 24.12 4.35 27.52 61.77 17.56s-.53-.83-.23-5.34z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "437.175px 345.645px 0"
    },
    id: "elfglr3bb4na",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cf0a10",
      transformOrigin: "441.24px 361.31px 0"
    },
    id: "elhbt0840roe",
    className: "animable",
    d: "m412.92 372.23-2.77-33.2 32.3-6.54 29.03 42.96.85 14.68-44.64-1.39-14.77-16.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.58 329.09a8.28 8.28 0 0 1 .37 1.56c.21 1 .47 2.48.77 4.29.59 3.64 1.25 8.69 1.91 14.27s1.25 10.62 1.75 14.27c.25 1.75.45 3.2.6 4.31a9.27 9.27 0 0 1 .17 1.59 10.91 10.91 0 0 1-.37-1.56c-.21-1-.47-2.47-.76-4.29-.6-3.64-1.26-8.68-1.91-14.26s-1.26-10.63-1.76-14.27c-.24-1.75-.44-3.21-.6-4.32a10.66 10.66 0 0 1-.17-1.59z",
    style: {
      fill: "#263238",
      transformOrigin: "407.365px 349.235px 0"
    },
    id: "elm2inypxmao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386 341.07s4.33.55 5.85 1.34 5.95 3.72 5.95 3.72l8.92 1.69-2.13 14.74-6-3-13.16 1.31s-2.87-.66-2.87-2.71a5.42 5.42 0 0 1-2.55-3.86 60.45 60.45 0 0 1-3.84-5.51c-.32-.89 1.47-3 1.47-3s3.76 3.19 6 3.69 4.35-.4 4.55-1.87c.45-2.95-2.19-6.54-2.19-6.54z",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "391.426px 351.815px 0"
    },
    id: "elvw2d1v62r6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9bz9offgbsm"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "437.075px 356.934px 0"
    },
    className: "animable",
    id: "ely67dbbhtqsj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.66 366.5s30 10.74 40 10.1c8.51-.54 12.7-4.53 13.38-10.1s1.61-29.26 1.61-29.26l-16.05 27.87-39.1-1.23z",
    id: "elugqnzjfpnco",
    style: {
      transformOrigin: "437.075px 356.934px 0"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M458.3 365c2.16-6.16 4.53-18 4.53-18l3.73-19.73a21.4 21.4 0 0 0-4.86-14.14c-2.45-2.94-5.88-5.45-10.46-5.43-9.69 0-9.35 17.91-9.35 17.91l-2.64 25.59-37.94-6.2-2.41 18.24 44.62 9.63a13.31 13.31 0 0 0 11-2.11 11.6 11.6 0 0 0 3.78-5.76z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "432.734px 340.483px 0"
    },
    id: "elffb7d4xkytt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.31 309.27c0 .08-.77.12-1.95.44a10.44 10.44 0 0 0-7 6c-.49 1.13-.64 1.89-.72 1.88a4.34 4.34 0 0 1 .37-2 9.7 9.7 0 0 1 7.22-6.24 4.4 4.4 0 0 1 2.08-.08z",
    style: {
      fill: "#263238",
      transformOrigin: "447.472px 313.386px 0"
    },
    id: "elu43cflpphpc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.56 327.26s0 .17-.06.48-.14.79-.24 1.38l-.95 5.32c-.43 2.31-.95 5.14-1.55 8.41s-1.31 7-2.26 11.09c-.47 2.05-1 4.19-1.58 6.4-.29 1.11-.62 2.23-1 3.37a23.2 23.2 0 0 1-1.31 3.43 10.78 10.78 0 0 1-2.21 3.11 12 12 0 0 1-3.31 2.13 13.85 13.85 0 0 1-8.08.85l-35.28-7.59-9.91-2.14-.24-.05v-.23c.83-6.3 1.64-12.4 2.41-18.25v-.25h.25l38.04 6.28-.21.16c.85-7.93 1.54-14.32 2-18.75.24-2.18.44-3.88.57-5.06.07-.56.12-1 .16-1.31s.07-.45.07-.45v.45c0 .29-.06.76-.11 1.32-.11 1.18-.27 2.88-.48 5.07-.43 4.44-1.07 10.83-1.85 18.77v.19h-.19l-38-6.12.28-.21c-.76 5.84-1.56 11.94-2.39 18.24l-.13-.3 9.91 2.13 35.26 7.63a13.32 13.32 0 0 0 7.8-.8 11 11 0 0 0 3.19-2 10.36 10.36 0 0 0 2.14-3 23.71 23.71 0 0 0 1.29-3.36c.35-1.13.68-2.25 1-3.35.61-2.21 1.13-4.34 1.61-6.38 1-4.08 1.72-7.79 2.33-11.07s1.19-6.08 1.64-8.39.8-4.06 1.05-5.3c.12-.58.22-1 .29-1.37s.05-.48.05-.48z",
    style: {
      fill: "#263238",
      transformOrigin: "432.571px 349.538px 0"
    },
    id: "elo1fqoil00k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.66 357.68a18 18 0 0 1-2.53-3.35c-.64-1-1.19-1.89-1.58-2.49a2 2 0 0 0-.89-.7s.12-.09.36-.05a1.58 1.58 0 0 1 .81.52 28.6 28.6 0 0 1 1.73 2.43 17.05 17.05 0 0 1 2.1 3.64z",
    style: {
      fill: "#263238",
      transformOrigin: "441.16px 354.38px 0"
    },
    id: "elwzas1ii2lmb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.17 334.25s-6.75-17.12.29-25.49a8 8 0 0 1 6.72-2.76c2.22.17 5.17.6 7.06 1.69 0 0-6-1.07-8.49 1.58-1.84 2-6.27 8.31-1.6 23.48z",
    style: {
      fill: "#cf0a10",
      transformOrigin: "442.747px 320.112px 0"
    },
    id: "el0zjzs6kmuxo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.27 339.83-6.88-22.56a3.89 3.89 0 0 1 4.14-1.94l6.64 24.5z",
    style: {
      fill: "#cf0a10",
      transformOrigin: "408.78px 327.545px 0"
    },
    id: "elghc4wgh505",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.84 347.81c-.09.11-3.82-2.7-8.34-6.28a104.13 104.13 0 0 1-8-6.68c.09-.11 3.82 2.7 8.34 6.28a104.13 104.13 0 0 1 8 6.68z",
    style: {
      fill: "#455a64",
      transformOrigin: "379.67px 341.33px 0"
    },
    id: "eljqc2vegesh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "369.53px 334.15px 0"
    },
    id: "el41m1o12ea8",
    className: "animable",
    d: "m369.9 335.7-2.05-1.89.98-1.21 2.38 1.6-1.31 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.62 306.2a3.55 3.55 0 0 1 2.44-4.29c3.72-1.1 9.46-2.47 11-1 2.37 2.17 8 7.42 8 7.42l7.82 16.23-12.66 3.73-3.6-12.35s-5.76.31-5.25-2.78c0 0-2.88-1.13-2.47-2.88s2.78-2.16 2.78-2.16l-.51-3.09-7.57 1.33z",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "365.194px 314.279px 0"
    },
    id: "eltvlv52oz1p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.85 310.49h-6.38V303h6.38a3.76 3.76 0 0 1 3.76 3.76 3.77 3.77 0 0 1-3.76 3.73z",
    style: {
      fill: "#455a64",
      transformOrigin: "355.54px 306.745px 0"
    },
    id: "el4y95kanlepu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.71 306.59-9.58-2.47s-2.57-.72-1.23 2.06 5.35 2.16 6.89 3.81 2.42 4.43 8.81 5.46",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "358.557px 309.743px 0"
    },
    id: "eluu4uk1oug3n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.6 315.45a5.91 5.91 0 0 1-1.27-.14 13.55 13.55 0 0 1-3.31-1.06 8.69 8.69 0 0 1-2-1.35 14.82 14.82 0 0 1-1.82-2.08c-1-1.73-3.36-1.64-5.44-2.59a4.66 4.66 0 0 1-1.42-1 4.52 4.52 0 0 1-.87-1.45 3.15 3.15 0 0 1-.19-.83 1.12 1.12 0 0 1 .34-.89 1.89 1.89 0 0 1 1.65-.16l4.94 1.33 3.32.94a6.62 6.62 0 0 1 1.2.41 5.34 5.34 0 0 1-1.25-.21l-3.37-.79-5-1.22a1.45 1.45 0 0 0-1.19.08c-.25.19-.18.71 0 1.16a4.14 4.14 0 0 0 .76 1.28 4.54 4.54 0 0 0 1.27.87 27.12 27.12 0 0 0 3.05 1 5.39 5.39 0 0 1 1.47.66 5.07 5.07 0 0 1 1.07 1.11 15.31 15.31 0 0 0 1.74 2.06 9.27 9.27 0 0 0 1.89 1.34 26.26 26.26 0 0 0 4.43 1.53z",
    style: {
      fill: "#eb996e",
      transformOrigin: "358.438px 309.615px 0"
    },
    id: "elrbeb1fw6k6n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366 362.11a6.66 6.66 0 0 1-5.56-3.31 9.9 9.9 0 0 1-.4-8.77c.08-.18.16-.37.25-.54l-.09-.23a16.73 16.73 0 0 1-.9-5.25c-.36-5.86-.7-11.31-1-16.75s-.66-10.92-1-16.79h.5c.36 5.87.7 11.33 1 16.79s.66 10.89 1 16.75a16.57 16.57 0 0 0 .81 5 4.89 4.89 0 0 1 2.89-2.36 3.14 3.14 0 0 1 2.51.52 2.89 2.89 0 0 1 1.25 2.09 3.18 3.18 0 0 1-3.34 3.38 4.53 4.53 0 0 1-3.34-2.52l-.08.18a9.4 9.4 0 0 0 .36 8.31 5.85 5.85 0 0 0 6.7 2.81c2.33-.84 4.15-3.65 4.42-6.85a17 17 0 0 0-2-8.71c-.64-1.34-1.38-2.65-2.09-3.92s-1.48-2.64-2.13-4a7.56 7.56 0 0 1-.91-3.23 3 3 0 0 1 1.62-2.86 1.82 1.82 0 0 1 2.38 1.84h-.49a1.26 1.26 0 0 0-.52-1.1 1.29 1.29 0 0 0-1.19-.23 2.57 2.57 0 0 0-1.3 2.4 7.23 7.23 0 0 0 .86 3c.64 1.37 1.39 2.7 2.12 4s1.45 2.59 2.1 3.95a17.39 17.39 0 0 1 2 9c-.24 2.86-1.8 6.22-4.74 7.28a5.15 5.15 0 0 1-1.69.12zm-5.15-12.61a4.26 4.26 0 0 0 3.12 2.58 2.57 2.57 0 0 0 2-.81 2.48 2.48 0 0 0 .77-2 2.4 2.4 0 0 0-1-1.73 2.61 2.61 0 0 0-2.1-.45 4.68 4.68 0 0 0-2.76 2.41z",
    style: {
      fill: "#455a64",
      transformOrigin: "364.876px 336.301px 0"
    },
    id: "el67x18vwuzlg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.24 454.09 23.12-7.91S463.16 467 467.58 466l-13.72-45.4-36.54 10.84z",
    style: {
      fill: "#455a64",
      transformOrigin: "442.45px 443.317px 0"
    },
    id: "ele3ptln7v16",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.15 432.74a1.93 1.93 0 0 1 1.73-1.92 1.86 1.86 0 0 1 1.92 1.69 2.05 2.05 0 0 1-1.84 2 1.93 1.93 0 0 1-1.8-2",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "442.975px 432.664px 0"
    },
    id: "elf93ah7v7iu6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.8 420.28-3.54 1 13.47 43.56s1.5 1.76 2.85 1.1z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "459.42px 443.184px 0"
    },
    id: "elv9judgvb8y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.35 447c.22-.07 0-1.21.37-2.51s1.14-2.17 1-2.35-1.33.54-1.77 2.13.21 2.82.4 2.73z",
    style: {
      fill: "#263238",
      transformOrigin: "447.768px 444.559px 0"
    },
    id: "elonlbhyepnc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.76 451.15c.23 0 .32-1.09 1-2.13s1.63-1.55 1.56-1.77-1.38 0-2.24 1.33-.53 2.63-.32 2.57z",
    style: {
      fill: "#263238",
      transformOrigin: "451.921px 449.164px 0"
    },
    id: "elbimk9qqnfuv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.27 452.13c0-.22-1.21-.19-2.25.75s-1.21 2.11-1 2.15.67-.8 1.54-1.55 1.76-1.12 1.71-1.35z",
    style: {
      fill: "#263238",
      transformOrigin: "455.607px 453.524px 0"
    },
    id: "el11r1ev9odo8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.88 448.2c.18-.15-.44-1.08-.73-2.36s-.19-2.37-.42-2.43-.73 1.12-.36 2.62 1.37 2.33 1.51 2.17z",
    style: {
      fill: "#263238",
      transformOrigin: "441.075px 445.814px 0"
    },
    id: "elo1pqzxawn3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.43 392.43c-.89-.24-40.05 41.76-40.94 48.71s.53 13 5.16 16.9 57.31-8.9 57.31-8.9l-5-22.07 19-6.4-17-31.15z",
    style: {
      fill: "#cf0a10",
      transformOrigin: "418.599px 424.15px 0"
    },
    id: "els8970esat1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elg9a7urrqse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "431.075px 413.007px 0"
    },
    className: "animable",
    id: "elzcoqpdjcyyf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m412.16 401.74-1.25 1.35s22.44 23.55 29.33 23.22l11-3.73L414 399.7z",
    id: "el1cs77tq749p",
    style: {
      transformOrigin: "431.075px 413.007px 0"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M438.11 427.65c0 .14-8.13 2.66-18.24 5.63s-18.36 5.27-18.4 5.13 8.13-2.65 18.25-5.63 18.35-5.27 18.39-5.13z",
    style: {
      fill: "#263238",
      transformOrigin: "419.79px 433.03px 0"
    },
    id: "elvjosad5pttb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.21 430.08 7.61 24.14s-22 15.85-21 20.45l47.35-13.08-10.31-38.11z",
    style: {
      fill: "#455a64",
      transformOrigin: "399.478px 449.075px 0"
    },
    id: "elanchshwdjb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.89 448.13a2 2 0 0 1 1.95 1.83 1.93 1.93 0 0 1-1.81 2 2.12 2.12 0 0 1-2-2c.07-1 1.14-2 2.1-1.81",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "410.936px 450.043px 0"
    },
    id: "eliu1b3owy7a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.46 462.58-1-3.7L377 471.75s-1.86 1.5-1.21 2.92z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "399.556px 466.775px 0"
    },
    id: "el1y0cstkw576",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 454.19c.08.23 1.26 0 2.6.45s2.22 1.23 2.41 1.08-.53-1.39-2.16-1.88-2.97.16-2.85.35z",
    style: {
      fill: "#263238",
      transformOrigin: "398.516px 454.7px 0"
    },
    id: "elihg7l0cm5iq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.59 457.62c0 .24 1.11.35 2.17 1.11s1.57 1.74 1.79 1.66 0-1.42-1.31-2.34-2.71-.65-2.65-.43z",
    style: {
      fill: "#263238",
      transformOrigin: "393.606px 458.9px 0"
    },
    id: "el5vkdliaf12w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.41 464.34c.22 0 .22-1.25-.72-2.35s-2.16-1.31-2.21-1.09.81.71 1.57 1.63 1.12 1.85 1.36 1.81z",
    style: {
      fill: "#263238",
      transformOrigin: "389.004px 462.582px 0"
    },
    id: "el12sa3gh7bj39",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.86 448.5c.15.18 1.13-.43 2.46-.7s2.46-.14 2.53-.38-1.14-.78-2.71-.44-2.44 1.37-2.28 1.52z",
    style: {
      fill: "#263238",
      transformOrigin: "397.347px 447.702px 0"
    },
    id: "el35reu8m5pgo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1qur469rsp8g"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "415.23px 429.53px 0"
    },
    className: "animable",
    id: "ellq32kd9ja7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "elpnybl0u6wha",
    style: {
      transformOrigin: "415.23px 429.53px 0"
    },
    className: "animable",
    d: "m423.49 453.54-2.92-11.45 2.18-1.01-13.25-36.06-2.53 2.2 10.41 33.03 3.73 13.79 2.38-.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M392.23 364.28a18.56 18.56 0 0 0-14.9 3.2 13.65 13.65 0 0 0-5.56 13.67c2.13 15 21.24 66 21.24 66l26.44-7.95c.15 0 .3-.48.21-.35-.21.35-13.41-42.16-13.08-41.66s26.68 21.81 37.62 25.67a24.28 24.28 0 0 0 27.72-8.28c2.56-3.58 2.74-19.32 0-27.64 0 0-76.3-21.63-77.73-22.16a15.68 15.68 0 0 0-1.96-.5z",
    style: {
      fill: "#cf0a10",
      transformOrigin: "422.723px 405.508px 0"
    },
    id: "elu8what1w7ks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.15 379.84a35.85 35.85 0 0 1 15.5 25.16",
    style: {
      fill: "#cf0a10",
      transformOrigin: "398.9px 392.42px 0"
    },
    id: "el67fxbdznyfx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473 414.06-.32.51a15.8 15.8 0 0 1-1.07 1.39 24.06 24.06 0 0 1-5.21 4.37 26.56 26.56 0 0 1-10.12 3.85 23.31 23.31 0 0 1-6.85.09 22.52 22.52 0 0 1-7.38-2.22c-1.26-.53-2.45-1.25-3.72-1.9s-2.51-1.43-3.77-2.23q-3.79-2.35-7.78-5.12-8-5.52-16.64-12.42l-2.16-1.75-1.08-.9-.29-.27-.14-.13c.09 0-.25-.12.19.06.35-.37.1-.18.18-.22v.07l.19.68c.56 1.8 1.12 3.63 1.7 5.49q1.76 5.55 3.59 11.37c2.48 7.76 5.06 15.86 7.73 24.23l.08.24-.25.08-26.77 8.06-.24.07-.08-.23c-1.71-4.58-3.48-9.45-5.25-14.4-3.84-10.74-7.49-21.26-10.7-31.53-1.61-5.13-3.11-10.2-4.31-15.25-.15-.63-.32-1.25-.44-1.89s-.23-1.27-.35-1.9a17.58 17.58 0 0 1-.37-3.83 13.46 13.46 0 0 1 2.12-7.23 17.43 17.43 0 0 1 12.16-7.35 19.1 19.1 0 0 1 7 .29l1.67.43 1.61.48 3.19.95 23.41 7 33.9 10.16 9.21 2.79 2.39.73c.54.17.81.27.81.27s-.28-.06-.83-.22l-2.4-.68-9.24-2.7-34-10-23.44-6.94-3.19-.94-1.64-.47-1.61-.4a18.85 18.85 0 0 0-6.79-.28 16.94 16.94 0 0 0-11.82 7.16 12.88 12.88 0 0 0-2 7 17 17 0 0 0 .37 3.75c.11.62.23 1.25.35 1.88s.29 1.25.43 1.88c1.2 5 2.7 10.08 4.32 15.21 3.21 10.25 6.86 20.77 10.7 31.51 1.77 4.94 3.54 9.82 5.24 14.39l-.31-.16 26.78-8-.17.31c-2.66-8.37-5.23-16.47-7.7-24.23q-1.83-5.83-3.58-11.39c-.57-1.85-1.13-3.69-1.69-5.5l-.19-.69v-.1c.08-.06-.18.08.17-.29.47.19.15.06.26.12l.12.1.24.21 1.07.9 2.15 1.75c5.75 4.59 11.3 8.76 16.59 12.45 2.64 1.86 5.23 3.56 7.75 5.14 1.25.79 2.52 1.5 3.74 2.23s2.45 1.37 3.69 1.91a22.29 22.29 0 0 0 7.29 2.22 22.82 22.82 0 0 0 6.77-.06 26.51 26.51 0 0 0 10.07-3.75 24.37 24.37 0 0 0 5.23-4.28 16 16 0 0 0 1.1-1.36c.16-.41.33-.57.33-.57z",
    style: {
      fill: "#263238",
      transformOrigin: "422.184px 405.557px 0"
    },
    id: "elr66rb0n3qzm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.5 385.47a9.49 9.49 0 0 1 2.2 1.19 32.22 32.22 0 0 1 4.74 3.74 28.76 28.76 0 0 1 3.92 4.59 8.13 8.13 0 0 1 1.22 2.19 19.77 19.77 0 0 1-1.52-2 36.77 36.77 0 0 0-4-4.43 45.4 45.4 0 0 0-4.59-3.81 17.5 17.5 0 0 1-1.97-1.47z",
    style: {
      fill: "#263238",
      transformOrigin: "400.54px 391.325px 0"
    },
    id: "el1vepleejv8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.53 382.52a7.87 7.87 0 0 1 1 2 34.54 34.54 0 0 1 1.55 5.1 33.23 33.23 0 0 1 .75 5.27 8.5 8.5 0 0 1 0 2.21c-.16 0-.33-3.35-1.24-7.37s-2.21-7.15-2.06-7.21z",
    style: {
      fill: "#263238",
      transformOrigin: "405.21px 389.81px 0"
    },
    id: "elzk9urr7h0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462 381.48 9.66-2.78 6.31 1.14 3 10.54c3 9.32 2.33 14.66-3.85 18.75-1.81 1.2-3.53 1.86-4.78 1.33C468 408.62 462 381.48 462 381.48z",
    style: {
      fill: "#455a64",
      transformOrigin: "472.35px 394.673px 0"
    },
    id: "elr5hrs3wi17",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "440.835px 378.17px 0"
    },
    id: "elh94xslxjaf",
    className: "animable",
    d: "m471.66 378.7-61.65-10.14.14.82 61.51 18.4v-9.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-77",
    style: {
      transformOrigin: "93.4221px 290.494px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight,1.5s Infinite linear floating",
      animationDelay: "0s,1s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.88 426.67 80.82 448s19.31 13.39 18.57 17.43L58.24 455l8.11-33.55z",
    style: {
      fill: "#455a64",
      transformOrigin: "78.8254px 443.44px 0"
    },
    id: "elz1h342dmyoo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.54 442.91a1.75 1.75 0 0 0-1.64 1.65 1.69 1.69 0 0 0 1.6 1.67 1.85 1.85 0 0 0 1.73-1.76c-.08-.86-1-1.75-1.85-1.54",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "68.565px 444.564px 0"
    },
    id: "el51ywnup81cn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2h5qj4y0udv"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "78.868px 458.54px 0"
    },
    className: "animable",
    id: "elng9ghot7xt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.24 455 .95-3.35 39.1 11.25s1.63 1.28 1.1 2.53z",
    style: {
      fill: "#fff",
      transformOrigin: "78.868px 458.54px 0"
    },
    id: "elowwx16601fs",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M81.54 447.9c-.06.2-1.08 0-2.23.45s-1.89 1.12-2.06 1 .43-1.23 1.83-1.7 2.55.08 2.46.25z",
    style: {
      fill: "#263238",
      transformOrigin: "79.3834px 448.414px 0"
    },
    id: "ell3qicxidqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.41 450.81c0 .2-1 .33-1.85 1s-1.32 1.55-1.52 1.49 0-1.25 1.09-2.08 2.32-.61 2.28-.41z",
    style: {
      fill: "#263238",
      transformOrigin: "83.6911px 451.964px 0"
    },
    id: "elyo3snguqhcp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.57 456.66c-.2 0-.22-1.09.57-2.07s1.84-1.19 1.88-1-.69.64-1.32 1.45-.93 1.65-1.13 1.62z",
    style: {
      fill: "#263238",
      transformOrigin: "87.7374px 455.094px 0"
    },
    id: "el5qnz3zc8t1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.39 442.9c-.13.16-1-.35-2.14-.56s-2.13-.07-2.19-.27 1-.72 2.33-.45 2.14 1.14 2 1.28z",
    style: {
      fill: "#263238",
      transformOrigin: "80.2316px 442.237px 0"
    },
    id: "eli3cbqvy6wt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.46 431.68-1 22.12s21.88 8.42 22.1 12.53L51.19 466l.09-34.54z",
    style: {
      fill: "#455a64",
      transformOrigin: "72.375px 448.895px 0"
    },
    id: "el89pvpr7kn8p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4 451.84a1.76 1.76 0 0 0-1.21 2 1.68 1.68 0 0 0 1.94 1.24A1.85 1.85 0 0 0 60.4 453a1.71 1.71 0 0 0-2.15-1.06",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "58.7939px 453.475px 0"
    },
    id: "elwrjxvzia0cn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwntynio7w8i"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "72.404px 464.43px 0"
    },
    className: "animable",
    id: "elwhtzfh3vqz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.19 466 .14-3.48 40.61 1.62s1.88.85 1.66 2.2z",
    style: {
      fill: "#fff",
      transformOrigin: "72.404px 464.43px 0"
    },
    id: "elhv7l84lnov9",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M72.19 453.59c0 .21-1 .3-2.07 1s-1.57 1.55-1.76 1.46.13-1.29 1.38-2.07 2.5-.58 2.45-.39z",
    style: {
      fill: "#263238",
      transformOrigin: "70.2504px 454.737px 0"
    },
    id: "el46cme60l9bp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.63 455.49c0 .2-.86.55-1.57 1.44s-.92 1.82-1.12 1.8-.33-1.19.57-2.27 2.11-1.17 2.12-.97z",
    style: {
      fill: "#263238",
      transformOrigin: "75.2124px 457.068px 0"
    },
    id: "el9vbgjr7fnvh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.11 460.91c-.19 0-.47-1 .07-2.16s1.52-1.59 1.6-1.42-.51.79-.94 1.74-.52 1.82-.73 1.84z",
    style: {
      fill: "#263238",
      transformOrigin: "79.8266px 459.102px 0"
    },
    id: "elkvh9xrt1rz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.86 448.52c-.09.19-1-.1-2.21 0s-2.08.44-2.19.26.78-.93 2.16-1 2.38.58 2.24.74z",
    style: {
      fill: "#263238",
      transformOrigin: "69.662px 448.303px 0"
    },
    id: "elgifp56tdz3n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.22 269.75v17.5l4.64 68.16S48 388.48 46.2 407.15c-1.54 16.21 1 44.44 1 44.44h27l9.66-94.15 6-58.72 10.4-26.72z",
    style: {
      fill: "#263238",
      transformOrigin: "72.9822px 360.67px 0"
    },
    id: "elauc4c0pafts",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.53 269.75 2.61 71.05c-.18 13.33-3.85 38.22-8.62 50.65L84.83 439.1l-1.25 4.29-16.13-3.95L79.44 271z",
    style: {
      fill: "#263238",
      transformOrigin: "91.295px 356.57px 0"
    },
    id: "el4p38buemlox",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.85 288.57a2.3 2.3 0 0 1 0 .43v6.04c0 4.17 0 10.2-.13 17.65s-.36 16.32-.89 26.16-1.24 20.69-3.55 31.85C87.25 381.87 85 392.47 83 402.11s-3.78 18.33-5.11 25.66-2.3 13.28-2.89 17.41c-.31 2.06-.47 3.67-.62 4.75-.07.53-.13.94-.17 1.24a2 2 0 0 1-.08.42 2.31 2.31 0 0 1 0-.43c0-.3.06-.71.11-1.24.12-1.09.25-2.7.53-4.77.49-4.14 1.38-10.1 2.66-17.45s3-16 5-25.69 4.24-20.24 6.37-31.41c2.3-11.13 3-22 3.58-31.78s.82-18.69 1-26.14.25-13.47.3-17.64V289a3.42 3.42 0 0 1 .17-.43z",
    style: {
      fill: "#455a64",
      transformOrigin: "83.99px 370.08px 0"
    },
    id: "elq6oeurp9v1a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.84 251.59a12.11 12.11 0 0 1 .4 4.09c-.2 2.09-.3 7.25-5.88 9s-10.85-2.43-12.55-4.32-1.51-8.08-1.51-8.08l9.17-4.08z",
    style: {
      fill: "#cf0a10",
      transformOrigin: "118.283px 256.649px 0"
    },
    id: "elfanhdr1na3v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.45 172.86-4.64 7.46-18.81 8 4.71 77.21 3.38 14 62.63-2.08 1.55-10.84v-52.07c-1.42-13.36-7.87-21.66-13.86-24.95l-3.91-2.68L94 182l-5.52-5.17-17.69-4.59z",
    style: {
      fill: "#cf0a10",
      transformOrigin: "77.135px 225.885px 0"
    },
    id: "el5h1jm4e4ou5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elma7p6rv063e"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "78.405px 257.31px 0"
    },
    className: "animable",
    id: "elamf7v0evfzh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.63 259.66a19.19 19.19 0 0 0 18.92 8.42c6.29-1.06 11.6-5.21 17.63-7.28 10.49-3.62 22.46-.74 32.8-4.77.2-1.78.08-4 .2-5.18-5.17-.27-10.68-.56-15.25-3l-4.15-1.53z",
    id: "elk2i4yt9ph2",
    style: {
      transformOrigin: "78.405px 257.31px 0"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M41 188.33s-8.93 7.64-6.34 27.56c2.4 18.5 6.66 44.28 12.34 47.27s17.94 1.49 26.91-3.59 35-18.84 35-18.84l-10.77-19.14-34.69 13.46s-4.49-30.7-7.18-36",
    style: {
      fill: "#cf0a10",
      transformOrigin: "71.5494px 226.509px 0"
    },
    id: "el1eu5fues22r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.27 199.07s.1.19.27.58c.08.2.2.44.31.74l.34 1.05c.51 1.58 1.12 4 1.78 7.07 1.34 6.21 3 15.25 4.66 26.51l-.25-.15 34.67-13.5.19-.08.11.18c3.4 6.05 7 12.48 10.77 19.13l.13.23-.25.17-22.24 12-10.91 5.87c-1.79 1-3.58 2-5.43 2.76a45.89 45.89 0 0 1-5.67 2 37.54 37.54 0 0 1-11.57 1.34 16.94 16.94 0 0 1-5.56-1.17l-.65-.29a6 6 0 0 1-.63-.39 7 7 0 0 1-1-1 13.84 13.84 0 0 1-1.47-2.36 53.87 53.87 0 0 1-3.47-10c-.88-3.33-1.57-6.6-2.19-9.76-1.23-6.34-2.14-12.28-2.9-17.71s-1.43-10.38-1.23-14.75a36.79 36.79 0 0 1 2-11 24 24 0 0 1 3.29-6.25 13.41 13.41 0 0 1 1.19-1.4 3.73 3.73 0 0 1 .46-.42l-.43.45c-.27.31-.67.78-1.14 1.43a25.37 25.37 0 0 0-3.18 6.26 36.74 36.74 0 0 0-1.87 10.93c-.17 4.34.52 9.26 1.3 14.69s1.72 11.35 3 17.67c.63 3.16 1.33 6.42 2.21 9.73a53.11 53.11 0 0 0 3.46 9.94 13.78 13.78 0 0 0 1.42 2.28 6.29 6.29 0 0 0 .93.93 4.26 4.26 0 0 0 .55.34l.62.28a16.26 16.26 0 0 0 5.4 1.12A36.64 36.64 0 0 0 64.64 263a44.73 44.73 0 0 0 5.6-1.94c1.83-.79 3.57-1.78 5.37-2.74l10.92-5.88 22.25-12-.1.35-10.75-19.08.29.1-34.71 13.41-.21.09v-.24c-1.66-11.25-3.22-20.31-4.49-26.51-.63-3.11-1.21-5.5-1.68-7.09-.12-.4-.22-.75-.32-1.06l-.28-.74c-.19-.39-.26-.6-.26-.6z",
    style: {
      fill: "#263238",
      transformOrigin: "71.6471px 226.735px 0"
    },
    id: "elapjapznvuh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cf0a10",
      transformOrigin: "73.015px 215.885px 0"
    },
    id: "elnsp1l88p1q",
    className: "animable",
    d: "m59.26 210.41 22.53-1.48 4.98 9.37-25.25 4.54-2.26-12.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.26 210.41a8.21 8.21 0 0 1 .21.9c.12.63.29 1.46.5 2.5.42 2.19 1 5.25 1.74 9l-.23-.16 22.73-4.15 2.52-.45-.19.37c-1.74-3.3-3.42-6.45-5-9.37l.23.12-16.14.94-4.68.25h-1.72a2.39 2.39 0 0 1 .4 0l1.2-.11 4.62-.37 16.29-1.19h.16l.07.14 5 9.36.17.31-.35.07-2.51.45-22.76 4h-.19v-.19c-.64-3.82-1.17-6.94-1.55-9.17-.17-1-.3-1.85-.4-2.46a7 7 0 0 1-.12-.79z",
    style: {
      fill: "#263238",
      transformOrigin: "73.185px 215.855px 0"
    },
    id: "el6tfxjwm9d0k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.45 235.05c.14.11-1.88 2.48-3.56 5.86s-2.4 6.42-2.58 6.37a6.93 6.93 0 0 1 .38-2 24.77 24.77 0 0 1 1.73-4.6 24.3 24.3 0 0 1 2.63-4.15 6.72 6.72 0 0 1 1.4-1.48z",
    style: {
      fill: "#263238",
      transformOrigin: "60.3834px 241.165px 0"
    },
    id: "elz7njseef5fs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.08 192.12a7.77 7.77 0 0 1-1.25-.89l-3.27-2.6h.28a30.28 30.28 0 0 1-4.47 5.61l-.16.16-.18-.15-3.45-2.87c-3.7-3-7.16-5.64-9.68-7.5l-3-2.21a7 7 0 0 1-1.06-.85 7.05 7.05 0 0 1 1.18.69c.74.47 1.8 1.17 3.09 2.07 2.58 1.79 6.08 4.37 9.79 7.4 1.21 1 2.38 2 3.45 2.89H77a32.84 32.84 0 0 0 4.5-5.46l.12-.19.16.15 3.22 2.69a10.58 10.58 0 0 1 1.08 1.06z",
    style: {
      fill: "#263238",
      transformOrigin: "72.96px 187.61px 0"
    },
    id: "elwa1v7vi8qa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.34 187.39a3.6 3.6 0 0 1 .18 1.25 18.24 18.24 0 0 1-.11 3.34l-.07.59-.34-.5a41.09 41.09 0 0 0-2.68-3.46c-.4-.47-.81-.91-1.21-1.33a8.19 8.19 0 0 0-.58-.59c-.2-.13-.17-.13-.35.06l-1.66 2.31a13.19 13.19 0 0 1-1.64 2.07 13.5 13.5 0 0 1 1.34-2.28l1.58-2.39a.65.65 0 0 1 1-.16c.26.22.42.4.64.62.41.42.83.87 1.24 1.35a31.16 31.16 0 0 1 2.66 3.55l-.42.1c.45-2.69.31-4.53.42-4.53z",
    style: {
      fill: "#263238",
      transformOrigin: "91.2158px 189.351px 0"
    },
    id: "elzpvp0jgz4f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.24 196a12.36 12.36 0 0 1-1.4-1.66 18.09 18.09 0 0 0-3.69-3.58 12.06 12.06 0 0 0-4.74-1.76 15.32 15.32 0 0 1-2.14-.33 6.49 6.49 0 0 1 2.19 0 11 11 0 0 1 5 1.79 15.27 15.27 0 0 1 3.7 3.78 7.43 7.43 0 0 1 1.08 1.76z",
    style: {
      fill: "#263238",
      transformOrigin: "49.255px 192.288px 0"
    },
    id: "el0ykwj9gs0uf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19 209.86a25 25 0 0 1-1.78-4.8 25.73 25.73 0 0 1-1.29-5 25.21 25.21 0 0 1 1.79 4.81 25.42 25.42 0 0 1 1.28 4.99z",
    style: {
      fill: "#263238",
      transformOrigin: "102.655px 204.96px 0"
    },
    id: "el1wtyjho2vwu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.05 254a8.66 8.66 0 0 1 .2 2c.08 1.22.22 2.9.3 4.77a31.45 31.45 0 0 1-.1 4.81 5.59 5.59 0 0 1-.43 2 12.43 12.43 0 0 1 .06-2v-4.76c0-1.86-.16-3.55-.14-4.78a6.28 6.28 0 0 1 .11-2.04z",
    style: {
      fill: "#263238",
      transformOrigin: "113.251px 260.79px 0"
    },
    id: "el7n00e8vjpwa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.17 217a1.21 1.21 0 1 0 .3-.23",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "73.0472px 217.833px 0"
    },
    id: "elbvh1vcg3jmp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elh3ru1znqpk9"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "71.335px 218.33px 0"
    },
    className: "animable",
    id: "eln3mgulkeqa"
  }, /*#__PURE__*/React.createElement("path", {
    id: "el146kzhalw12p",
    style: {
      transformOrigin: "71.335px 218.33px 0"
    },
    className: "animable",
    d: "m57.76 203.66 6.32 18.72 20.83-3.74-20.08 7.87-1.69 6.49-5.38-29.34z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elvb67kv0ndco"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "72.63px 189.575px 0"
    },
    className: "animable",
    id: "elsqgbs3b2ykg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.38 181.15 79 198l2.88-7.88 3 1-3.23-2.68s-3.54 5.44-4.48 5.54z",
    id: "el36zqmprhqvb",
    style: {
      transformOrigin: "72.63px 189.575px 0"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M95.87 221.51a5.33 5.33 0 0 1-.38-1.13c-.23-.84-.53-1.89-.88-3.13-.74-2.64-1.81-6.27-3.12-10.25s-2.63-7.52-3.61-10.09c-.45-1.2-.84-2.21-1.15-3a5.92 5.92 0 0 1-.38-1.14 5.3 5.3 0 0 1 .56 1.06c.33.69.78 1.71 1.32 3 1.06 2.53 2.43 6.08 3.75 10.06s2.34 7.65 3 10.32c.33 1.33.57 2.42.72 3.17a4.89 4.89 0 0 1 .17 1.13z",
    style: {
      fill: "#263238",
      transformOrigin: "91.11px 207.14px 0"
    },
    id: "elabjntmub4i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6 200.72c3.52 3.51 12.44 12.67 12.44 12.67l2.39-1.44-12.57-13.42a1.58 1.58 0 0 0-2-.24 1.57 1.57 0 0 0-.26 2.43z",
    style: {
      fill: "#263238",
      transformOrigin: "102.785px 205.714px 0"
    },
    id: "el0uby2pusshwr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.14 221.59 3-8.44a4.74 4.74 0 0 1 4.33-3.24 2.26 2.26 0 0 1 .45 0c1.8.2 11 .8 11 .8l3.55 4a1.85 1.85 0 0 1 0 2.41l1 7.17-2 1.37.2 5s-1.8 1.2-2.59.8l-.8-.4-1.2-1.2-3.39 4.79-4.69 2.71z",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "109.805px 223.629px 0"
    },
    id: "el4jspxwau23l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.48 217.49a16.07 16.07 0 0 0-1.29-1.4 6.11 6.11 0 0 0-1.71-1 13.15 13.15 0 0 0-2.48-.34 43 43 0 0 1-6.55-.87 40.63 40.63 0 0 1 6.6.35 11.4 11.4 0 0 1 2.59.41 5.49 5.49 0 0 1 1.8 1.21 3.15 3.15 0 0 1 1.04 1.64z",
    style: {
      fill: "#eb996e",
      transformOrigin: "114.465px 215.677px 0"
    },
    id: "elnmd5ajucj9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.28 224.09a14.21 14.21 0 0 0-.74-1.84 7.12 7.12 0 0 0-3.54-3 13.74 13.74 0 0 0-4.69-.79 10.09 10.09 0 0 1-2-.06 5.82 5.82 0 0 1 2-.3 11.56 11.56 0 0 1 4.89.67 6.94 6.94 0 0 1 3.68 3.28 3.14 3.14 0 0 1 .4 2.04z",
    style: {
      fill: "#eb996e",
      transformOrigin: "114.811px 221.077px 0"
    },
    id: "el37oqtbmq7wv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.38 230.25a3.83 3.83 0 0 1-.48-2 6.61 6.61 0 0 0-.45-2.06 2.58 2.58 0 0 0-1.89-1.43 35.24 35.24 0 0 0-4.77-.69 5.23 5.23 0 0 1-2-.46 15.46 15.46 0 0 1 2 .1 23.14 23.14 0 0 1 4.88.55 3.85 3.85 0 0 1 1.35.62 2.74 2.74 0 0 1 .84 1.12 6.2 6.2 0 0 1 .37 2.22c.04 1.27.21 2 .15 2.03z",
    style: {
      fill: "#eb996e",
      transformOrigin: "114.591px 226.929px 0"
    },
    id: "elwuso77aq71s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "118.815px 235.59px 0"
    },
    id: "eldpgtjcg3btp",
    className: "animable",
    d: "m124.37 214.4-39.54 40.84 1.52 1.54 28.33-3.19 38.12-36.32-.04-1.74-28.39-1.13z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluhyitqd9ya"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "120.227px 244.904px 0"
    },
    className: "animable",
    id: "elhvoajzhl1uh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.93 240.06a7.45 7.45 0 0 0-5.71-1.91 10.47 10.47 0 0 0-5.63 2.38 7.6 7.6 0 0 0-2.8 4c-.66 2.83 1.22 5.79 3.78 7.16l.35-.41 9.74-7.82a2.74 2.74 0 0 0 1.13-1.44 2.28 2.28 0 0 0-.86-1.96z",
    id: "elkubzuxb1xp",
    style: {
      transformOrigin: "120.227px 244.904px 0"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.76 236.24s3.83.08 5.08.7 4.69 4.29 4.69 4.29 0 2.49-1 2.59a9.43 9.43 0 0 1 .2 1.69c.1 1.4.3 2.2-1.6 3.39 0 0 .2 2.3-.5 2.89a13.57 13.57 0 0 1-1.49 1.1s-2.19 2.69-3.49 2.49-3.17 1.4-3.17 1.4-7-2.92-6.3-3.75l2.44-2.7s-4.83-3.52-4.73-4.62.5-1.19.5-1.19-.2-2.1 1.49-2.3c0 0 1.3-2.59 2.59-2.69s10.07 3.09 10.07 3.09l-3.29-2.79s-3.29-.5-3.19-1.59 1.7-2 1.7-2z",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "122.709px 246.51px 0"
    },
    id: "el9zedwsijsl7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.17 249.38c-.08.12-2-1-4.44-2.16a45.75 45.75 0 0 1-4.46-2.15 15.74 15.74 0 0 1 4.68 1.68 15.25 15.25 0 0 1 4.22 2.63z",
    style: {
      fill: "#eb996e",
      transformOrigin: "117.72px 247.229px 0"
    },
    id: "elbqefgv5imr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.74 246.32a33.92 33.92 0 0 1-5.72-1.85 34 34 0 0 1-5.54-2.35 35.75 35.75 0 0 1 5.72 1.88 35.69 35.69 0 0 1 5.54 2.32z",
    style: {
      fill: "#eb996e",
      transformOrigin: "121.11px 244.22px 0"
    },
    id: "el6owl9ry7mst",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.65 217.2a3 3 0 0 1-.52 0h-1.51l-5.67-.07-19.71-.38.18-.07-9.91 10.32c-8 8.25-15.25 15.7-20.54 21.15l-6.27 6.36-1.7 1.7a5.42 5.42 0 0 1-.63.57 5.45 5.45 0 0 1 .56-.65l1.65-1.78 6.15-6.48 20.43-21.25 9.93-10.25.07-.08h.11l19.71.57 5.66.21 1.51.07a1.81 1.81 0 0 1 .5.06z",
    style: {
      fill: "#263238",
      transformOrigin: "119.51px 236.535px 0"
    },
    id: "elkagz9ee6zkj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.2 135.87a7.5 7.5 0 0 0-4.86-2.5 4.77 4.77 0 0 0-3.15.24 3.77 3.77 0 0 0-1.62 3.64 15.19 15.19 0 0 0 1.21 4 7.23 7.23 0 0 1 .57 4.11l3.59 8.55a4.53 4.53 0 0 0 2.32-6.52 4.38 4.38 0 0 0 1.29-6.64c1.64-.88 1.77-3.39.65-4.88z",
    style: {
      fill: "#263238",
      transformOrigin: "99.7324px 143.559px 0"
    },
    id: "eltvbzswt15h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.08 158.19-.42-17.28-10.94-.5a3.65 3.65 0 0 0-1.31 6.45 4.5 4.5 0 0 0 .65 8.44 4.51 4.51 0 0 0 2.9 7.3c0 2 1.14 4.24 3.1 4.8s4.26-.93 5.18-2.87.89-4.19.84-6.34z",
    style: {
      fill: "#263238",
      transformOrigin: "63.4295px 153.965px 0"
    },
    id: "eltcswsuhvjaq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.42 138.5s1.08 14.3 2.48 18.66a44.17 44.17 0 0 0 4.48 9.06l33.36-10.36c1.13-7.72 2.3-15.48 1.82-21.56l-10.64-3.79z",
    style: {
      fill: "#263238",
      transformOrigin: "80.5453px 148.365px 0"
    },
    id: "elp9gu4ydeqcc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.48 157.16a72 72 0 0 1-3.25-11.77 24.62 24.62 0 0 1 .8-12.06c.2-.59 2-4.5 2.6-4.44.44 0-.64 3.67-.41 4.05a21 21 0 0 1 2.53 12.18 55.62 55.62 0 0 1-2.27 12",
    style: {
      fill: "#263238",
      transformOrigin: "65.8355px 143.025px 0"
    },
    id: "el7k252d9ptx3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.64 183.93v-9.68s9.86-1.14 10.36-10.93c.25-4.73 0-14.51-.41-23.35a18.26 18.26 0 0 0-17.54-17.49h-.94c-10.21.19-15.75 9-15.27 19.18v33.16L86 189.34z",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "82.9555px 155.91px 0"
    },
    id: "el8btsdses8sy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.66 174.25a23.66 23.66 0 0 1-12.6-4.25s2.83 7.25 12.64 6.75z",
    style: {
      fill: "#eb996e",
      transformOrigin: "83.38px 173.387px 0"
    },
    id: "elyv6gyzzjhaq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.41 148.34A1.4 1.4 0 0 1 95 149.7a1.33 1.33 0 0 1-1.39-1.31A1.4 1.4 0 0 1 95 147a1.33 1.33 0 0 1 1.41 1.34z",
    style: {
      fill: "#263238",
      transformOrigin: "95.01px 148.349px 0"
    },
    id: "el2tecsqym58",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.36 144c-.18.17-1.21-.65-2.72-.71s-2.64.66-2.79.47.11-.41.61-.74a3.81 3.81 0 0 1 2.24-.6 3.67 3.67 0 0 1 2.15.79c.45.32.6.66.51.79z",
    style: {
      fill: "#263238",
      transformOrigin: "94.5963px 143.219px 0"
    },
    id: "el6pu4h906jbt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.92 148.58a1.4 1.4 0 0 1-1.4 1.36 1.35 1.35 0 0 1-1.4-1.32 1.41 1.41 0 0 1 1.41-1.36 1.34 1.34 0 0 1 1.39 1.32z",
    style: {
      fill: "#263238",
      transformOrigin: "81.52px 148.6px 0"
    },
    id: "elp5fm97qgdol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.59 144c-.18.18-1.21-.65-2.72-.7s-2.63.65-2.79.46.11-.41.61-.74a3.85 3.85 0 0 1 2.24-.6 3.77 3.77 0 0 1 2.16.79c.44.36.59.69.5.79z",
    style: {
      fill: "#263238",
      transformOrigin: "79.8245px 143.221px 0"
    },
    id: "el47eikryvqi1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.54 155.76a9.71 9.71 0 0 1 2.46-.35c.38 0 .75-.08.83-.34a2 2 0 0 0-.22-1.15q-.48-1.42-1-3c-1.41-4.23-2.42-7.7-2.25-7.76s1.46 3.33 2.87 7.56c.34 1 .67 2 1 3a2.28 2.28 0 0 1 .15 1.52 1 1 0 0 1-.66.54 2.65 2.65 0 0 1-.66.06 10.39 10.39 0 0 1-2.52-.08z",
    style: {
      fill: "#263238",
      transformOrigin: "89.3942px 149.521px 0"
    },
    id: "el7ed0v0nck4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.07 156.63c.24 0 .18 1.63 1.53 2.84s3.1 1.1 3.11 1.33-.4.3-1.14.29a4 4 0 0 1-2.59-1 3.55 3.55 0 0 1-1.19-2.38c-.03-.71.21-1.1.28-1.08z",
    style: {
      fill: "#263238",
      transformOrigin: "85.2488px 158.86px 0"
    },
    id: "eldebv85xy3a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.28 138.81c-.16.4-1.66.15-3.43.29s-3.22.57-3.44.2c-.1-.18.16-.56.75-.93a5.74 5.74 0 0 1 2.58-.79 5.61 5.61 0 0 1 2.66.42c.6.28.95.62.88.81z",
    style: {
      fill: "#263238",
      transformOrigin: "79.839px 138.503px 0"
    },
    id: "elc536hdk4hut",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.93 138.92c-.28.33-1.3-.06-2.55-.13s-2.31.14-2.54-.23c-.1-.17.08-.51.56-.81a3.47 3.47 0 0 1 2.09-.48 3.57 3.57 0 0 1 2 .76c.43.37.56.73.44.89z",
    style: {
      fill: "#263238",
      transformOrigin: "94.3929px 138.154px 0"
    },
    id: "el1smnkefluo7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.37 148.91c-.16-.08-6.65-2.26-6.7 4.45s6.69 5.37 6.71 5.18-.01-9.63-.01-9.63z",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "63.0283px 153.642px 0"
    },
    id: "eltw0utmsrfv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.35 156s-.12.08-.32.17a1.11 1.11 0 0 1-.87 0 2.86 2.86 0 0 1-1.32-2.6 3.89 3.89 0 0 1 .34-1.67 1.36 1.36 0 0 1 .88-.89.6.6 0 0 1 .69.33c.09.18 0 .32.08.33s.15-.11.09-.39a.7.7 0 0 0-.26-.42.9.9 0 0 0-.64-.18 1.65 1.65 0 0 0-1.23 1 4 4 0 0 0-.42 1.87 3.05 3.05 0 0 0 1.69 2.91 1.3 1.3 0 0 0 1.07-.17c.2-.15.24-.29.22-.29z",
    style: {
      fill: "#eb996e",
      transformOrigin: "62.8597px 153.591px 0"
    },
    id: "el97uhfxt3eyj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.25 128.87c1.09-.6-2.17-4.11-4.84-5.32-4-1.82-10.19-2.94-13.91-1.88-4.47 1.28-8.18 3.51-10.42 7.59a26.33 26.33 0 0 0-2.94 13.47 8 8 0 0 0 1 4.09c.94 1.48 2.74 2.41 2.66 4.46a2.84 2.84 0 0 0 .7 2c1.23 1.31 2.73.08 3.42-1.15 1.47-2.63 1.63-5.77 1.75-8.78a19.71 19.71 0 0 0-.43-6.37c-.33-1.12-.86-2.17-1.13-3.31a4.08 4.08 0 0 1 .47-3.35 4.69 4.69 0 0 1 .55-.55 7 7 0 0 1 6.87-1.29c3.78 1.33 10.23 3.31 11.91 2a10.41 10.41 0 0 0 3-3z",
    style: {
      fill: "#263238",
      transformOrigin: "79.2864px 137.55px 0"
    },
    id: "elkjmxx9e7lkj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.29 114.74c-.47.05-11.94 2.24-15.08 10.63s-2.38 11-2.38 11a5.32 5.32 0 0 0-1.22 1c-.49.54.11 3.23 1.6 3 11.29-4.55 24.47-4.6 39.12-3.66l11.23.24c3.13.47 4.27-.33 3-1.16-1-.64-9.8-4.52-9.8-4.52l-1.76-1.36-4.42-6.58s.6-.88-.51-1.66-10.45-7.91-19.78-6.93z",
    style: {
      fill: "#cf0a10",
      transformOrigin: "85.2562px 127.516px 0"
    },
    id: "el6gfnzm2sj8u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 129.91a3.64 3.64 0 0 1-.44 0l-1.25-.07c-1.09-.08-2.66-.12-4.61-.14a87.5 87.5 0 0 0-15.11 1.3 132.92 132.92 0 0 0-14.78 3.56c-1.87.54-3.37 1-4.41 1.34l-1.2.36-.43.12.41-.15 1.19-.4c1-.34 2.54-.84 4.4-1.4a124.6 124.6 0 0 1 14.79-3.61 83.54 83.54 0 0 1 15.16-1.31c3.9.1 6.28.4 6.28.4z",
    style: {
      fill: "#263238",
      transformOrigin: "79.885px 132.945px 0"
    },
    id: "elqasgqvddv0a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elw28u37i9hyl"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "78.235px 120.138px 0"
    },
    className: "animable",
    id: "el5ap86l297fc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.73 119.39s12.33-1.57 17.74 1.26l-.63-.34 5.16 2.45a3.23 3.23 0 0 0 2.74.42 24.21 24.21 0 0 0-7.77-4.49c-5.11-1.91-13.24-2.93-17.24.7z",
    id: "el4mpdnkuieoe",
    style: {
      transformOrigin: "78.235px 120.138px 0"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.55 119.45a7.87 7.87 0 0 1 1.12-.68 15.06 15.06 0 0 1 3.34-1.3 18.3 18.3 0 0 1 5.28-.57 15.21 15.21 0 0 1 6.33 1.46 26.6 26.6 0 0 1 2.92 1.7c.9.6 1.8 1.14 2.61 1.74a18.22 18.22 0 0 0 2.33 1.59 5.45 5.45 0 0 0 2.36.55c3 .15 4.88-.42 4.76-.61a.55.55 0 0 1-.25.23 4.52 4.52 0 0 1-.94.28 16.5 16.5 0 0 1-3.58.24 5.48 5.48 0 0 1-2.42-.55 17.45 17.45 0 0 1-2.36-1.59c-.8-.59-1.71-1.13-2.61-1.73a28.17 28.17 0 0 0-2.9-1.68 15.13 15.13 0 0 0-6.25-1.46 18.53 18.53 0 0 0-5.25.53 16.54 16.54 0 0 0-3.34 1.23c-.38.19-.66.35-.85.46z",
    style: {
      fill: "#263238",
      transformOrigin: "81.0777px 120.491px 0"
    },
    id: "elrvonzyk2qw8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrx32nrldu9r"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "68.7867px 127.77px 0"
    },
    className: "animable",
    id: "el1n48p9denlg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 128.87a27.18 27.18 0 0 0 6.09-.86c2.34-.43 4.66-.75 7-1.29 1.76-.41 3.84-.77 5-2a2.57 2.57 0 0 1-.86 2.36 12.39 12.39 0 0 1-3.78 1.52 65.25 65.25 0 0 1-14 2.22 14.25 14.25 0 0 1 .56-2",
    id: "ellfaavndb3on",
    style: {
      transformOrigin: "68.7867px 127.77px 0"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M61.6 124.45c-1.41.56-2.28.94-2.36 2.12-.07 1 .09 2.21 1.06 2.41a2.73 2.73 0 0 0 .9 0l15.28-2.55a2.29 2.29 0 0 0 1.42-.6 1.53 1.53 0 0 0-.45-2.1 4.2 4.2 0 0 0-2.31-.6 50.66 50.66 0 0 0-13.54 1.35",
    style: {
      fill: "#cf0a10",
      transformOrigin: "68.6826px 126.058px 0"
    },
    id: "elchh3tak1f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.66 126a1.47 1.47 0 0 0 .43-.65 1.91 1.91 0 0 0-.56-1.94 4.73 4.73 0 0 0-3-.78c-1.22 0-2.56.06-4 .15a40.68 40.68 0 0 0-7.13 1c-.89.21-1.61.44-2.1.59l-.57.18-.2.06s.06 0 .19-.09l.56-.22a20.34 20.34 0 0 1 2.09-.65 36.78 36.78 0 0 1 7.15-1.08c1.41-.09 2.76-.12 4-.13a4.81 4.81 0 0 1 3.12.85 2 2 0 0 1 .54 2.06 1.36 1.36 0 0 1-.33.51z",
    style: {
      fill: "#263238",
      transformOrigin: "69.4012px 124.213px 0"
    },
    id: "el3fhrsom3514",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "93.995px 126.295px 0"
    },
    id: "elq7yilbtx0ug",
    className: "animable",
    d: "m97.98 125.39-9.54-.52.71 2.72 10.4.13-1.57-2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.25 133.38s4.27-.51 9.55-1 9.58-.9 9.58-.85-4.27.51-9.56 1-9.57.9-9.57.85z",
    style: {
      fill: "#263238",
      transformOrigin: "92.815px 132.455px 0"
    },
    id: "el8kqsestbu3v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "78.405px 274.455px 0"
    },
    id: "elltb7ml6486e",
    className: "animable",
    d: "M41.67 268.32h73.47v12.27H41.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.92 274.25h34v34.48a6.92 6.92 0 0 1-6.92 6.92H50.84a6.92 6.92 0 0 1-6.92-6.92v-34.48z",
    style: {
      fill: "#455a64",
      transformOrigin: "60.92px 294.95px 0"
    },
    id: "elk5aqkf3fmx9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.94 285.46a14.65 14.65 0 0 1-.14-2.13 24.76 24.76 0 0 0-.75-5.71 3.87 3.87 0 0 0-.88-1.58 9.52 9.52 0 0 0-1.6-1.25 10.13 10.13 0 0 0-4.26-1.35c-3.2-.24-6.79-.13-10.53-.1s-7.35-.3-10.48.39a6.87 6.87 0 0 0-3.9 2 6.72 6.72 0 0 0-1.24 3.63c-.23 2.43-.18 4.42-.22 5.79v1.58a3.43 3.43 0 0 1 0 .55 2 2 0 0 1-.06-.55c0-.42 0-.94-.05-1.58 0-1.37-.12-3.35.06-5.82a7.14 7.14 0 0 1 1.27-3.87 7.22 7.22 0 0 1 4.14-2.17 22.45 22.45 0 0 1 5.12-.44h5.46c3.75 0 7.3-.13 10.58.14a10.51 10.51 0 0 1 4.43 1.46 9.63 9.63 0 0 1 1.66 1.34 4.08 4.08 0 0 1 1 1.75 22.47 22.47 0 0 1 .6 5.81v1.58a3.16 3.16 0 0 1-.21.53z",
    style: {
      fill: "#263238",
      transformOrigin: "60.9746px 280.049px 0"
    },
    id: "elait5doesyrv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.69 289.09c0 .15-7.48.26-16.71.26s-16.71-.11-16.71-.26 7.48-.26 16.71-.26 16.71.17 16.71.26z",
    style: {
      fill: "#263238",
      transformOrigin: "60.98px 289.09px 0"
    },
    id: "elws1oarkfhsa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.66 316c-.15 0-.26-6.05-.26-13.51s.11-13.52.26-13.52.26 6.05.26 13.52S53.8 316 53.66 316z",
    style: {
      fill: "#263238",
      transformOrigin: "53.66px 302.485px 0"
    },
    id: "elxoxny1nlt2p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 315.91c-.14 0-.26-6-.26-13.38s.12-13.39.26-13.39.26 6 .26 13.39-.12 13.38-.26 13.38z",
    style: {
      fill: "#263238",
      transformOrigin: "69px 302.525px 0"
    },
    id: "elyh1alibokc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.14 268.32 4.24 5.93s3.79 35.34 2.1 37-7.37 1.62-7.37 1.62l-1.55-42.31z",
    style: {
      fill: "#455a64",
      transformOrigin: "117.237px 290.595px 0"
    },
    id: "elugkqdecc7l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.83 280.1a38.85 38.85 0 0 1-.16-11.92 55.61 55.61 0 0 1 .14 6 55 55 0 0 1 .02 5.92z",
    style: {
      fill: "#263238",
      transformOrigin: "101.593px 274.14px 0"
    },
    id: "elt37buzjat5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.22 268.52a7.11 7.11 0 0 1 .45 2c.2 1.24.4 3 .51 4.89a10.32 10.32 0 0 1-.11 2.74 3.47 3.47 0 0 1-1.15 2 2.36 2.36 0 0 1-1.43.58c-.38 0-.56-.09-.56-.11a2.88 2.88 0 0 0 1.74-.75 3.17 3.17 0 0 0 .93-1.8 11.32 11.32 0 0 0 .06-2.63c-.2-3.83-.59-6.9-.44-6.92z",
    style: {
      fill: "#263238",
      transformOrigin: "114.577px 274.625px 0"
    },
    id: "ellkizd13uxmi",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-77",
    style: {
      transformOrigin: "460.351px 251.436px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m452.51 274.1 4.68-4.42a20.53 20.53 0 1 0-7-2.4z",
    style: {
      fill: "#fff",
      transformOrigin: "460.239px 251.472px 0"
    },
    id: "el4eizows5ih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.51 274.1-.15-.46c-.1-.3-.24-.74-.42-1.31-.38-1.16-.94-2.86-1.66-5.08l-.08.08a.06.06 0 0 0 .08 0 .06.06 0 0 0 0-.07 20.47 20.47 0 0 1-7.29-7 20.07 20.07 0 0 1-1.46-2.81 23.34 23.34 0 0 1-1-3.22 20.38 20.38 0 0 1 39.25-10.92 20 20 0 0 1 .77 8.8 20.43 20.43 0 0 1-7.55 13.34l-.7.53a4.88 4.88 0 0 1-.7.49l-1.43.89a29.44 29.44 0 0 1-2.91 1.31 20.43 20.43 0 0 1-10 1h-.05c-1.5 1.44-2.66 2.54-3.44 3.3l-.9.86-.3.3.3-.27.89-.83 3.53-3.27h-.05a20.35 20.35 0 0 0 10.09-.95 24.92 24.92 0 0 0 2.93-1.31l1.45-.88a5.07 5.07 0 0 0 .72-.49l.7-.54a20.67 20.67 0 0 0 6.92-22.4 21.06 21.06 0 0 0-4.88-8.16 20.63 20.63 0 0 0-8.45-5.26 8.38 8.38 0 0 0-1.21-.35l-1.21-.29-1.22-.18a7.34 7.34 0 0 0-1.23-.13l-1.22-.06a10.1 10.1 0 0 0-1.23 0c-.4 0-.81 0-1.21.07l-1.19.18a20.32 20.32 0 0 0-8.62 3.55 20.56 20.56 0 0 0-8.06 21.67 23.32 23.32 0 0 0 1.06 3.25 21 21 0 0 0 1.48 2.83 20.56 20.56 0 0 0 7.4 7v-.12a.07.07 0 0 0-.08.05l1.75 5.1.44 1.29c.08.37.14.47.14.47z",
    style: {
      fill: "#263238",
      transformOrigin: "460.36px 251.436px 0"
    },
    id: "elze16t9e7vz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "459.995px 249.865px 0"
    },
    id: "elzbmwv24719",
    className: "animable",
    d: "m449.6 249.05 3.09-2.77 5.38 5.32 9.76-9.1 2.56 3.07-13.04 11.66-7.75-8.18z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.13bfab2b536c4bcad17e165508c56d25.svg";
export { ForwardRef as ReactComponent };